import createIcon from '../../createIcon';

/**
 * @component @name Output
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAxN0wyMS41IDEyTDE2LjUgN0wxNS4wOSA4LjQxTDE3LjY3IDExSDguNVYxM0gxNy42N0wxNS4wOSAxNS41OUwxNi41IDE3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4LjUgMTlINC41VjVIMTguNVY3SDIwLjVWNUMyMC41IDMuOSAxOS42MSAzIDE4LjUgM0g0LjVDMy40IDMgMi41IDMuOSAyLjUgNVYxOUMyLjUgMjAuMSAzLjQgMjEgNC41IDIxSDE4LjVDMTkuNjEgMjEgMjAuNSAyMC4xIDIwLjUgMTlWMTdIMTguNVYxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Output = createIcon('Output', [
  [
    'path',
    {
      d: 'M16.5 17L21.5 12L16.5 7L15.09 8.41L17.67 11H8.5V13H17.67L15.09 15.59L16.5 17Z',
      key: 'll6yg1',
    },
  ],
  [
    'path',
    {
      d: 'M18.5 19H4.5V5H18.5V7H20.5V5C20.5 3.9 19.61 3 18.5 3H4.5C3.4 3 2.5 3.9 2.5 5V19C2.5 20.1 3.4 21 4.5 21H18.5C19.61 21 20.5 20.1 20.5 19V17H18.5V19Z',
      key: '9mlhf7',
    },
  ],
]);

export default Output;
